import propTypes from 'prop-types';

export const initFunc = propTypes.func;
export const initProp = (type) => type;
